import {createContext, useContext, useState} from "react";
import {createContextProvider} from "@/components/widgets";
import {EndpointStatusDomainsQuery, useEndpointStatusDomainsLazyQuery} from "./queries.generated";

const useDomainListFetcherFactory = () => {
    const [loading, setLoading] = useState(false);
    const [domains, setDomains] = useState<EndpointStatusDomainsQuery["domains"]["items"]>([]);

    const [domainsQuery] = useEndpointStatusDomainsLazyQuery();

    const fetch = async (forceRefetch = false) => {
        if (loading || (domains.length && !forceRefetch)) return undefined;

        setLoading(true);

        const {data} = await domainsQuery({fetchPolicy: "no-cache"});

        setDomains(data.domains.items);

        setLoading(false);

        return data.domains.items;
    };

    return {
        loading,
        domains,
        fetch,
    };
};

const DomainFetcherContext = createContext(undefined);

export const useDomainListFetcher = (): ReturnType<typeof useDomainListFetcherFactory> =>
    useContext(DomainFetcherContext);

export const DomainFetcherFactoryContextProvider = createContextProvider(
    DomainFetcherContext,
    useDomainListFetcherFactory,
);
